import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';
import style from './companyAssets.module.css';
const CompanyAssets = () => {
  const data = useStaticQuery(
    graphql`
      query {
        allContentfulAssetLists(filter: { name: { eq: "Press Assets" } }) {
          edges {
            node {
              id
              name
              asset {
                id
                description
                asset {
                  fluid(maxHeight: 270) {
                    ...GatsbyContentfulFluid
                  }
                  file {
                    url
                  }
                  fixed {
                    aspectRatio
                  }
                  description
                }
                photoCredit
                downloadLink
              }
            }
          }
        }
      }
    `,
  );

  const assetsData = data.allContentfulAssetLists.edges[0].node.asset;

  return (
    <main className={style.assetsWrapper}>
      <h3>Company Assets</h3>

      <ul className={style.assetsList}>
        {assetsData.map(item => (
          <li className={style.assetsItems} key={item.id}>
            <Img
              fluid={item.asset[0].fluid}
              style={{
                borderRadius: 6,
                aspectRatio:
                  item.asset[0].fixed.aspectRatio < 1 ? null : '35/27',
              }}
              alt={'App promo'}
            />

            <div className={`${style.downloadButton} bodytext-2`}>
              <a
                href={item.downloadLink || `https:${item.asset[0].file.url}`}
                download
                rel="nofollow"
              >
                <span>Download photo&nbsp;</span>
                <img src="/images/download.svg" />
              </a>
            </div>
            <p className={`${style.assetInfo} bodytext-2`}>
              {item.description}
              <br />
              {item.photoCredit && item.photoCredit.length > 0
                ? `Photo credit: ${item.photoCredit}`
                : null}
            </p>
          </li>
        ))}
      </ul>
    </main>
  );
};
export default CompanyAssets;
